import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/delta2/h5/');

export default function DeltaPros({}: any) {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.deltaPros', //触发元素
            offset: layoutH / 2, //layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnter(true);
        });
        sceneA1.on('leave', function () {
            setIsEnter(false);
        });

        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.deltaPros} deltaPros GtmModuleData-section`} data-section-id={css.deltaPros} data-section-title={t('delta2.aniD_msg1')}>
            <div className="deltaPros-out">
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <div className={`deltaPros-in ${isEnter ? 'isEnter' : ''}`}>
                                    <div className="n-box">
                                        <div className="n-title">{t('delta2.aniD_msg1')}</div>
                                        <div className="n-sub">{t('delta2.aniD_msg2')}</div>
                                    </div>
                                    <div className="c-box">
                                        <div className="b-sub sub-move1">{t('delta2.aniD_msg3')}</div>
                                        <div className="b-sub sub-move2">{t('delta2.aniD_msg4')}</div>

                                        <div className="ms-title3-move ms-title3-move-1">2</div>
                                        <div className="ms-title3-move ms-title3-move-2">3</div>
                                        <div className="ms-unit">kWh</div>

                                        <div className="img-box-out">
                                            <div className="img-box img-box1">
                                                <div className="img-wrapper">
                                                    <EFPic name={['2kWhpro.webp', '2kWhpro.jpg']} loading="eager" />
                                                </div>
                                            </div>
                                            <div className="img-box img-box2">
                                                <div className="img-wrapper">
                                                    <EFPic name={['3kWhpro.webp', '3kWhpro.jpg']} loading="eager" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="img-title sub-move1">
                                            <span>{t('delta2.aniD_product1')}</span>
                                            <span>{t('delta2.aniD_product2')}</span>
                                        </div>
                                        <div className="img-title sub-move2">
                                            <span>{t('delta2.aniD_product1')}</span>
                                            <span>{t('delta2.aniD_product3')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
